export default "__VITE_ASSET___NiaaWcz__"